import React, {useState, useEffect, useRef} from "react";
import {DEFAULT_BLUE} from "../../../constants/general-constants";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {functions} from "../../../constants/common-functions";

export default function UserFacilityMatrixRow({userId, facilityId, facilityName, checkFunction, userFacilityMatricies, setAll}){
	
	
	const [displayDate, setDisplayDate] = useState("none");
	
	const checkbox = useRef(null);
	const dateTo = useRef(null);
	const dateFrom = useRef(null);
	
	useEffect(() => {
	}, [facilityId]);
	
	
	useEffect(() => {
		let found = false;
		for(let i=0; i<userFacilityMatricies.length; i++){
			if(userFacilityMatricies[i].facilityId === facilityId){
					found = true;
					setDisplayDate("flex");
					checkbox.current.checked = true;
					dateFrom.current.value = functions.parseDateFromDatabase(userFacilityMatricies[i].dateFrom);
					dateTo.current.value = functions.parseDateFromDatabase(userFacilityMatricies[i].dateTo);
					
			}
		}
		if(found === false){
			let yesterday = new Date();
			yesterday.setDate(yesterday.getDate() - 1);
			dateFrom.current.value = functions.parseDateToDBFormat(yesterday);
			dateTo.current.value = "9999-09-09";
		}
	}, [userFacilityMatricies]);
	
	const handleCheckChange = (e) => {
		if(checkbox.current.checked === true){
			setDisplayDate("flex");
		}
		else{
			setDisplayDate("none");
		}
		
		let isChecked = false;
		
		if(checkbox.current.checked === true){
			isChecked = true;
		}
		
		checkFunction(isChecked, facilityId, dateFrom.current.value, dateTo.current.value);
	};
	
	const thisContainer = {
		display:"flex",
		width:"calc(100% - 40px)",
		color:"black",
		height:"30px",
		alignItems:"center",
		backgroundColor:"white",
		marginTop:"1px",
		marginLeft:"20px"
	};
	
	const thisCheck = {
		display:"flex",
		width:"15px",
		height:"15px",
		backgroundColor:"rgba(0,0,0,0)",
		borderRadius:"5px"
	};
	
	const facilityNameContainer = {
		display:"flex",
		fontSize:"12px",
		color:"black",
		marginLeft:"5px",
		flexGrow:"1"
	};
	
	const dateContainer = {
		display:"flex",
		marginRight:"10px",
		alignItems:"center",
		fontSize:"12px",
		color:"black",
		display:displayDate
	};
	
	const thisDate = {
		display:"flex",
		width:"120px",
		backgroundColor:"rgba(0,0,0,0)",
		borderRadius:"5px",
		fontSize:"12px",
		border:"1px solid lightgrey",
		marginLeft:"5px",
		marginRight:"5px"
	};
	
	const applyButton = {
		display:"flex",
		width:"80px",
		alignItems:"center",
		justifyContent:"space-around",
		color:"white",
		backgroundColor:DEFAULT_BLUE,
		fontSize:"white",
		borderRadius:"4px",
		cursor:"pointer",
		fontSize:"12px",
		height:"20px"
	};
	
	const setAllFromHere = () => {
		setAll(facilityId, dateFrom.current.value, dateTo.current.value);
	};
	
	return (
		<div style={thisContainer}>	
				<input type="checkbox" style={thisCheck} onChange={handleCheckChange} ref={checkbox}/>
				<div style={facilityNameContainer}>
					{facilityName}
				</div>
				<div style={dateContainer}>
					From
					<input type="date" style={thisDate} ref={dateFrom} onChange={handleCheckChange}/>
					to
					<input type="date" style={thisDate} ref={dateTo} onChange={handleCheckChange}/>
					<div style={applyButton} onClick={setAllFromHere}>
						Apply All
					</div>
				</div>
		</div>
	);
}